import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import CurrencyFormat from '../../../../Helpers/Formatters/CurrencyFormat';
import GetAppIcon from '@material-ui/icons/GetApp';
import '../Status.scss';

export default function ApplicationSummary(props){
  const { firstName, lastName, coverageAmount, term, premium, emailAddress, includeFaq, passcode, birthdate, applicationID } = props;

  const useStyles = makeStyles(theme => ({
    emailEdit: {
      color: `${theme.palette.primary.main} !important`,
    },
  }));
  const classes = useStyles();

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  const downloadPDF = () => {
    fetch(`${covrServicesUrl}/api/AppStatus/GetAppPDF?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`)
      .then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = 'Application.pdf';
          a.click();
        });
      });
  }

  return (
    <React.Fragment>
      <div className="applicationSummary">
        <img src={process.env.PUBLIC_URL + '/americo/americo.png'} alt={'Americo Logo'} className="logo" />

        <p className="appSummaryTitle">Application Summary</p>

        <p className="appSummaryInfoTitle">Insured</p>
        <p className="appSummaryInfoText">{firstName + ' ' + lastName}</p>

        <p className="appSummaryInfoTitle">Email Address</p>
        <p className="appSummaryInfoText">{emailAddress}</p>

        <p className="appSummaryInfoTitle">Coverage amount</p>
        <p className="appSummaryInfoText"><CurrencyFormat number={coverageAmount} /></p>

        <p className="appSummaryInfoTitle">Product</p>
        <p className="appSummaryInfoText">{(term ? (term + ' Year') : '') + ' LoanMatch Protector'}</p>

        <p className="appSummaryInfoTitle">Premium</p>
        <p className="appSummaryInfoText"><CurrencyFormat number={premium} /></p>

        <Button color="primary" variant="contained" fullWidth className="mt-4" onClick={downloadPDF}><GetAppIcon className="downloadAppIcon" />Download application pdf</Button>
      </div>

      { includeFaq !== false &&
        <div className="faq mt-4">
          <h3>FAQs</h3>

          <h4>Is it safe to pass my personal information over the internet?</h4>
          <p>
            Yes, this site is completely secure through 256-bit TLS encryption. All necessary precautions and technologies have been put in place to protect our customers and their personal information.
          </p>
        </div>
      }
    </React.Fragment>

  )

}

ApplicationSummary.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  coverageAmount: PropTypes.number.isRequired,
  term: PropTypes.number,
  premium: PropTypes.number.isRequired,
  passcode: PropTypes.string.isRequired,
  birthdate: PropTypes.string.isRequired,
  applicationID: PropTypes.string.isRequired,
  includeFaq: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/Status/ApplicationSummary.js